export default "/images/vendor/flag-icons/flags/1x1/sh-hl.svg?b7c7cf30856bfaf28f35694c2f902e7f";